module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/issue-2/img/fair-trade-high-growth-300x300.ab2a11b4.jpg";